import React, { Component } from "react";

// Components
import Text from "../../components/base/Text";

class GeneralProfileFormFields extends Component {
  // Render the form fields
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <Text
              name="firstName"
              label="First Name"
              placeholder="Enter First Name"
              required={true}
              error=""
            />
          </div>
          <div className="col-lg-12 col-sm-12">
            <Text
              name="lastName"
              label="Last Name"
              placeholder="Enter Last Name"
              error=""
              required={true}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <Text
              name="email"
              label="Email"
              placeholder="Enter Email"
              required={true}
              error=""
            />
          </div>
        </div>
      </div>
    );
  }
}

export default GeneralProfileFormFields;
